<template>
    <div class="mb-3">
        <vaccine-card v-for="patientVaccine in patientVaccines" :name="patientVaccine.vaccine.name_ar"
                      :height="patientVaccine.height"
                      :weight="patientVaccine.weight"
                      :age="patientVaccine.age" :type="patientVaccine.vaccine.type"
                      :key="patientVaccine.id"></vaccine-card>

        <infinite-loading @infinite="load">
            <span slot="no-more"></span>
            <span slot="no-results"></span>
        </infinite-loading>

        <span slot="no-results" class="position-absolute absolute-center"
              v-if="complete && patientVaccines.length === 0">{{t('No results')}}</span>
    </div>
</template>

<script>
    import VaccineCard from "../../components/Cards/VaccineCard";
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        name: "Vaccines",
        components: {
            VaccineCard,
            InfiniteLoading
        },
        inject: ['dataRepo'],
        data: () => ({
            patientVaccines: [],
            complete: false,
            page: 0,
        }),
        methods: {
            load(state) {
                this.dataRepo.patientVaccines(this.page)
                    .then(data => {
                        if (data) {
                            this.patientVaccines.push(...data.data)
                            this.page++
                            state.loaded();
                        }

                        if (!data || data.data.length < 5) {
                            state.complete();
                            this.complete = true
                        }
                    })
                    .catch(err => this.$handleError(err))
            },
        }
    }
</script>

<style scoped>

</style>
